import { Component, OnInit } from '@angular/core';
import { CarrierService } from 'app/services/carrier.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Overlay, OverlayContainer, ToastrService } from 'ngx-toastr';
import { PopupService } from 'app/services/shared/popup.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { SelectorListContext } from '@angular/compiler';
import { PermitService } from 'app/services/permit.service';
import { ApplicationService } from 'app/services/application.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { environment } from 'environments/environment';
declare var $: any;

@Component({
  selector: 'app-ca-landing-page',
  templateUrl: './ca-landing-page.component.html',
  styleUrls: ['./ca-landing-page.component.css']
})
export class CaLandingPageComponent implements OnInit {
  dataCntrl: any = { carrierID: -1, carrier: {}, applications: [], applicationtype: {}, vehicles: [], applicationId: -1 };
  aCarrier: any = {};
  isLoading: boolean = false;
  isEmpty: boolean = false;
  listAccounts: any = [];
  listCarriers: any = [];
  user: any = {};
  page = 1;
  message: any;
  AccountStatus2: number = 0;
  smCode:any="";
  individualCarrierId: number;

  carrierId: any = "";
  carrierName: any = "";
  carrierTradingName: any = "";
  carrierType: any = "";
  carrierCountry: any = "";

  emptyCarrier: boolean = false;
  fetchedCarrier: boolean = false;

  errorMessage: any = "";
  importingCarrier: string = 'false';

  appId = 0;

  onboarding: number = 0;

  paygateEnabled = environment.paygateEnabled;
  
  constructor(private carrierService: CarrierService, private authWebService: AuthWebService, private router: Router,public utility: UtilityServiceService,
    private toaster: ToastrService, private showModal: PopupService,
    private activeRoute:ActivatedRoute, private msg: ToastrService,private confirmDialogService: ConfirmDialogService) {
    this.toaster.clear();
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
    console.log("User Data", this.user);
    console.log("Username", this.user.UserName);
    console.log("EmailAddress", this.user.EmailAddress);
    console.log("EmailAddress created ", "Facebook_"+this.user.UserName);
    if(this.user.MobileNumber === null || this.user.EmailAddress == null){//&& this.user.email == ""
      this.router.navigate(['/ammenduser']);
    }
  }

  ngOnInit() {
    this.activeRoute.params.subscribe((params: Params) => {
      this.smCode=params['id'];
    });
    this.utility.setShowStatementFooter(false);
    this.loadAccounts();

    this.AccountStatus2 = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus2").Value);
    this.onboarding = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "ONBOARD").Value);
    this.activeRoute.params.subscribe((params: Params) => {
      this.dataCntrl.carrierID = params['id'];
    });
    if (this.router.url.indexOf('cancel') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.carrierID = params['id'];
        this.appId = params['appid'];
      }
      );
    }
    var input = document.getElementById("searchButton");
    input.addEventListener("keyup", function(event) {
      if (event.key === '13') {
       event.preventDefault();
       document.getElementById("searchButton").click();
      }
    });
  }

  loadAccounts = () => {
    debugger;
    //alert("2");

    if (this.user) {
      this.isLoading = true;
      this.carrierService.listCarrierAccountsByUserId(this.user.Id).subscribe((result:any) => {
        if(this.smCode=='NEWAPP' && result.length==1){
          this.viewAcc(result[0], '/carrier/permit/application');
          this.isLoading = false;
          return false;
        }
        if (result.length > 1 || (this.smCode!='' && this.smCode!=undefined)) {
          this.listAccounts = result;
          for(let list of this.listAccounts){
            if(parseInt(list.account_balance)!=0){
              list.account_balance=-(parseInt(list.account_balance));
            }
          }

          this.isLoading = false;
        } else {
          if (result.length == 1) {
            this.viewAcc(result[0], '/carrier/permit/application/mypermits');
            this.isLoading = false;
          }
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        this.isEmpty = true;

        if (this.onboarding == 0) {
          // this.showModal.showYesNo('New Accounts', 'Would you like to create an account in order to apply for permits?', '', 'Yes', 'No')
          //               .subscribe((isConfirmed) => {
          //   if (isConfirmed) {
          //     this.router.navigate(['/carrier/account/add']);
          //     this.isLoading = false;
          //   } else {   
          //     return;
          //   }
          // });
          this.confirmDialogService.confirmThis("Would you like to create an account in order to apply for permits?", () => {  
          
            this.router.navigate(['/carrier/account/add']);
            this.isLoading = false;
      
          }, () =>  {  
            return;
          }) 
        } else {
          // this.showModal.showConfirm('Carrier Accounts', 'Would you like to create a new account or import your existing Account ?', 'If you are a consultant, close this message and then click Cancel. You will receive an invitation to link to an operator.', 'Create New Account', 'Import Existing Account')
          //             .subscribe((isConfirmed) => {
          //   if (isConfirmed) {
          //     this.router.navigate(['/carrier/account/add']);
          //     this.isLoading = false;
          //   } else {              
          //     // document.querySelector("#modal-dialog").
          //     $('#myModal').modal();
          //     // return;
          //   }
          // });
          this.confirmDialogService.confirmThis("Would you like to create a new account? If you are a consultant, close this message and then click Cancel. You will receive an invitation to link to an operator.", () => {  
            //alert("1.");
            this.router.navigate(['/carrier/account/add']);
            this.isLoading = false;
          }, () =>  {  
            $('#myModal').modal();
          })
        }
      })
    }
  }

  isReadOnly = (status: string): boolean => {
    return (status == "Submitted");
  }
  viewAcc(list, url) {
    if (list.status == 'AccountStatus3') {
      this.toaster.error('Your Carrier account has not been approved');
      return false;
    } else {
      this.router.navigate([url, list.id]);
    }
  }
  selectOptionList(optionVal, res) {
    switch (optionVal) {
      // Permits
      case "0":
        this.viewAcc(res, '/carrier/permit/application/mypermits');
        break;
      // Applications
      case "1":
        this.viewAcc(res, '/carrier/permit/application');
        break;
      // View Account
      case "2":
        this.router.navigate(['/carrier/account/edit/' + res.id + '/' + 1]);
        break;
      // Edit Account
      case "3":
        this.router.navigate(['/carrier/account/edit', res.id]);
        break;
      // Delete Account
      case "4":
        this.deleteAccount(res);
        break;
      // Un-Submit
      case "5":
        this.unsubmitAccount(res);
        break;
      // Account Statement
      case "6":
        this.router.navigate(['carrier/statement/' + res.carrier_account_id + '/' + res.id]);
        break;
      // Link Consultant
      case "7":
        this.router.navigate(['carrier/consultant/' + res.id]);
        break;
      // Annual Compliance
      case "8":
        this.router.navigate(['/carrier/compliance/return/list/'+ res.id +'/' + 0 ])
        break;
        // Fund Account
      case "9":
        this.router.navigate(['/carrier/fundaccount/'+ res.id])
        break;
      default:
        break;

    }
  }


  deleteAccount(acnt)
  {
    // this.showModal.showYesNo('Delete Account', 'Are you sure you want to delete account no.: ' + acnt.account_number + ' ?', `click the 'Yes' or 'No' button ->`, 'Yes', 'No').subscribe((userSelectedYes) => {
    //   if (userSelectedYes)
    //   {
    //     this.carrierService.delete(acnt.id).subscribe((msg:any) =>
    //       {
    //         if (msg == "There was a problem deleting the account.")
    //         {
    //           this.toaster.error(msg);
    //         }
    //         else
    //         {
    //           this.toaster.info("Account number " + acnt.account_number + " was successfully deleted.");
    //         }
    //       });
    //   }
    //   this.loadAccounts();
    // });
    this.confirmDialogService.confirmThis('Are you sure you want to delete account no.: ' + acnt.account_number + ' ?', () => {  
      this.carrierService.delete(acnt.id).subscribe((msg:any) =>
      {
        if (msg == "There was a problem deleting the account.")
        {
          this.toaster.error(msg);
        }
        else
        {
          this.toaster.info("Account number " + acnt.account_number + " was successfully deleted.");
        }
        this.loadAccounts();
      });

      
    }, () =>  {  
      //No here
    })
  }

  unsubmitAccount(acnt, key = 2)
  {
    //     let obj: any = {}

    // this.showModal.showYesNo('Un-Submit Account', 'Are you sure you want to unsubmit account ' + acnt.account_number + ' ?', `click the 'Yes' or 'No' button =>`, 'Yes', 'No').subscribe((userSelectedYes) => {
    //   if (userSelectedYes)
    //   {
    //     this.carrierService.getCompanyDetailsById(acnt.id).subscribe((obj:any) => {
    //       this.utility.isChanged = false;
    //       obj.Carrier.status_id = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus1").Value);
    //       this.isLoading = true;
    //       this.updateCACDetails(obj, key);
    //       this.utility.landingPage();
    //     });
    //   }
    // });
    this.confirmDialogService.confirmThis('Are you sure you want to unsubmit account ' + acnt.account_number + ' ?', () => {  
          
      this.carrierService.getCompanyDetailsById(acnt.id).subscribe((obj:any) => {
        this.utility.isChanged = false;
        obj.Carrier.status_id = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus1").Value);
        this.isLoading = true;
        this.updateCACDetails(obj, key);
        //alert('omg1');
        this.utility.landingPage();
      });
      
    }, () =>  {  
      //No here
    })
  }

  updateCACDetails = (obj: any, key = 2) => {
    this.message = "Updating carrier account's company details,please wait...";
    this.isLoading = true;
    this.carrierService.processUpdateCompanyDetails(obj).subscribe(result => {
      this.aCarrier = result;
      this.utility.docCtrl = (this.aCarrier.Carrier.carrier_id > 0) ? true : false;
      this.isLoading = false;
      this.utility.activeTab = key;
      this.msg.success("Carrier Account successfully un-submitted.", "Carrier Account", { timeOut: 1000 });
      this.loadAccounts();
    }, error => {
      this.isLoading = false;
      this.msg.error("Could not un-submit the Carrier Accout. Please contact the system administrator if the problem persists.", "Carrier Account")
      this.loadAccounts();
    });
  }

  showSuccess(msg) {
    this.msg.success(msg, 'Carrier Account Un-Submit');
  }

  showError = (msg) => {
    this.msg.error(msg, 'Carrier Account Un-Submit');
  }

  fetchCarrier(carrCode) {
    this.isLoading = true;
    if (carrCode == "" || carrCode == undefined){
      this.errorMessage = "Please enter a valid carrier number"
      this.emptyCarrier = true;
      this.fetchedCarrier = false;
      this.isLoading = false
    }
    else
    {
      this.emptyCarrier = false;

      let keyword: any = {};
      keyword.AccountNumber = (carrCode != "" && carrCode != null) ? carrCode : "All";
      keyword.Suffix = "All";
      keyword.Statuses = [];
      
      this.carrierService.searchCarrierAccounts(keyword, 1, 10, 6, true).subscribe((result:any) => {
        if (result.Count == 0) {          
          this.errorMessage = "Carrier Number was not found"
          this.emptyCarrier = true;
          this.fetchedCarrier = false;
          this.isLoading = false
        }
        else
        {
          this.carrierName = result.Accounts[0].Name;
          this.carrierTradingName = result.Accounts[0].TradingName;
          this.carrierType = result.Accounts[0].carrier_type;
          this.carrierCountry = result.Accounts[0].country;

          this.carrierId = result.Accounts[0].Id;

          this.carrierService.getCompanyDetailsById(result.Accounts[0].Id).subscribe((company:any) => {
            if (company.Carrier.user_id == null || company.Carrier.status_id == 93) {
              this.fetchedCarrier = true;
            }
            else
            {
              this.msg.warning(`The carrier has already been assigned. [${company.Contact.EmailAddress}]`, `Carrier Import`); // this.carrierName
              this.fetchedCarrier = false;
            }

            this.isLoading = false
          });
        }
      });
    }
  }

  importCarrier() {
    this.importingCarrier = 'true';
    localStorage.setItem('importCarrier',this.importingCarrier);
    this.router.navigate(['/carrier/account/edit', this.carrierId]);
  }

  cancelCarrier() {
    $('#carrierCode ').val("");
    this.fetchedCarrier = false;
    return;
  }

  checkKey(event){
    var carrierCode = document.getElementById("carrierCode");
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 13) {
      this.fetchCarrier($('#carrierCode ').Value);
      return;
    }
  }

  setCarrierCodeFocus() {
      $('#myModal').on('shown.bs.modal', function () {
          $('#carrierCode').focus();
      })  
  }
}
